import React from 'react'
import "./App.css"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {Footer} from "./containers";
import {Navbar} from "./components";
import Home from './Pages/Home';
import ProductPage from './Pages/ProductPage';
import Woix from './Pages/Woix';
import OurTeam from './Pages/Team';
import Projects from './Pages/Projects';
import Membership from './components/membership/membership.jsx';
import CaseSolution from './Pages/CaseSolution';

function App() {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home/>}/> 
        <Route path='/products' element={<ProductPage/>}/>
        <Route path='/team' element={<OurTeam/>}/>
        <Route path='/woix' element={<Woix/>}/>
        <Route path='/education' element={<CaseSolution/>}/>
        <Route path='/projects' element={<Projects/>}/> 
        <Route path='/membership/apply' element={<Membership/>}/>
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
